import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import Snackbar from '../Snackbar/index.js';
import { SnackbarContext } from '../Context/index.js';
import { SNACKBAR_DEFAULT_SHOW_DURATION } from '../types.js';
const Provider = ({ children }) => {
    const [snackbars, setSnackbars] = useState([]);
    let closeTimeoutId;
    function handleClose(id) {
        if (!id) {
            setSnackbars(prevSnackbars => prevSnackbars.filter(s => s.id !== String(prevSnackbars[prevSnackbars.length - 1].id)));
        }
        else {
            setSnackbars(prevSnackbars => prevSnackbars.filter(s => s.id !== String(id)));
        }
    }
    function handleOpen({ id, role = 'info', position = 'top-center', autoHideDuration = SNACKBAR_DEFAULT_SHOW_DURATION, ...openArgs }) {
        const snackbarId = id || snackbars.length.toString();
        setSnackbars(prevSnackbars => [
            ...prevSnackbars,
            { id: snackbarId, role, position, ...openArgs }
        ]);
        if (closeTimeoutId) {
            clearTimeout(closeTimeoutId);
        }
        if (autoHideDuration) {
            closeTimeoutId = window.setTimeout(() => handleClose(snackbarId), autoHideDuration);
        }
    }
    function isSnackbarActive(id) {
        if (id) {
            return !!snackbars.find(s => s.id === id);
        }
        return !!snackbars.find(s => s.id === snackbars[snackbars.length - 1].id);
    }
    return (_jsxs(SnackbarContext.Provider, { value: {
            onSnackbarOpen: handleOpen,
            onSnackbarClose: handleClose,
            isSnackbarActive: isSnackbarActive
        }, children: [snackbars.map((snackbar, index) => (_jsx(Snackbar, { index: index, ...snackbar, onClose: handleClose }, index))), children] }));
};
export default Provider;
//# sourceMappingURL=index.js.map